export const CACHE_KEY_LOOKUPS = 'ROLE_FORM_LOOKUPS_V2';

export const LOOKUP_MAPPING = {
    audition_type: 'auditionType', role_category: 'jobRoleCategory', talent: 'jobTalent',
    gender: 'gender', body_type: 'bodyType', nationality: 'nationality',
    experience_level: 'jobExperienceLevel', language: 'languages', hair_color: 'hairColor',
    hair_type: 'hairType', skin_color: 'skinColor', eye_color: 'eyeColour', dialect: 'dialect',driving_type: 'drivingType',people_appearance_list: 'peopleAppearanceList',
    age_year: 'ageRange', waist_size: 'waistSize', chest_size: 'chestSize', height_ft: 'height', special_category: 'specialCategory',sports_type: 'sportsType', esports_type: 'esportsType'
};

export const STATIC_OPTIONS = {
    status: [{value:'active', label:'Active'}, {value:'inactive', label:'Inactive'}],
    week_days: [
        {value: '0', label: 'Sunday'}, {value: '1', label: 'Monday'}, {value: '2', label: 'Tuesday'},
        {value: '3', label: 'Wednesday'}, {value: '4', label: 'Thursday'}, {value: '5', label: 'Friday'}, {value: '6', label: 'Saturday'}
    ],
    intervals: [{value: '15', label: '15 Minutes'}, {value: '30', label: '30 Minutes'}, {value: '60', label: '60 Minutes'}]
};

/* export const WIZARD_STEPS = [
    { id: 0, title: 'Role Details', fields: ['project_name', 'audition_type', 'role_name', 'role_category', 'gender', 'talent', 'status'] },
    { id: 1, title: 'Scene & Script', fields: [] },
    { id: 2, title: 'Locations', fields: ['auditionLocations'] }, // Validation on locations will check array
    { id: 3, title: 'Schedule', fields: [] },
    { id: 4, title: 'SEO & Meta', fields: ['metaTitle', 'metaKeywords', 'metaDescription'] }
];
 */
// --- FIX 1: WIZARD_STEPS is now a function ---
export const getWizardSteps = (isAdmin) => {
    const baseSteps = [
        { id: 0, title: 'Role Details', fields: ['project_name', 'audition_type', 'role_name', 'role_category', 'gender', 'talent', 'status'] },
        { id: 1, title: 'Scene & Script', fields: [] },
        { id: 2, title: 'Locations', fields: ['auditionLocations'] },
        { id: 3, title: 'Schedule', fields: [] }
    ];
    if (isAdmin) {
        return [...baseSteps, { id: 4, title: 'SEO & Meta',  component: 'seo',fields: ['metaTitle', 'metaKeywords', 'metaDescription'] }];
    }
    return baseSteps;
};